import React from 'react'
import classNames from 'classnames'
import {NavLink} from 'react-router-dom'
import PropTypes from 'prop-types'
import SidebarItem from './SidebarItem'
import {getReGenLabels} from "../../services/api/apiReGenerateLabel"
import PubSub from "pubsub-js"
import {logoutUser} from "../../services/AuthServices"
import { getQuantityWarning, getQuantityComboNotCompete } from '../../services/api/apiBrands'
import { notiCombineShip } from '../../services/api/apiPacking'
import { countFbaBatchPendingGenLabel } from '../../services/api/apiBatchShip'
import { countFbaBoxPendingLabelled } from '../../services/api/apiNextBox'
import { getAccessToken } from '../../services/AuthServices'
import { parseJwt } from '../../share/parseToken'
import { Tooltip } from 'antd'
import {
    RightOutlined,
    LeftOutlined
} from '@ant-design/icons';

class Sidebar extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isFullscreen: false,
            total: null
        }
    }

    componentDidMount() {
        this.loadStateFromProps()
        this._getReGenLabels()
        this._getQuantityWarning()
        this._getQuantityCombineShipNotGenLabel()
        this._getQuantityComboNotCompete()
        this._getFbaBatchPendingGenLabel()
        this._getFbaBoxPendingLabelled()
        PubSub.subscribe('LIST_RE_GENERATE_SIDEBAR', this._getReGenLabels)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.isFullscreen !== prevProps.isFullscreen
            || this.props.isOpenSidebarMobile !== prevProps.isOpenSidebarMobile) {
            this.loadStateFromProps()
        }
    }

    _getReGenLabels = async () => {
        this.setState({
            loading: true,
            error: ''
        })
        try {
            const payload = {"barcode": "", "reason": "", "status": "approved.pending", "page": 1, "limit": 50}

            const {data: respons} = await getReGenLabels(payload)
            const {success, data, message} = respons

            if (!success) return this.setState({
                error: message,
                loading: false
            })

            const {total} = data

            this.setState({
                total,
                loading: false
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }
    }

    _getQuantityWarning = async () => {
        this.setState({
            loading: true,
            error: ''
        })
        try {

            const {data: respons} = await getQuantityWarning()
            const {success, data, message} = respons

            if (!success) return this.setState({
                error: message,
                loading: false
            })

            const tagBrandWarning = data

            this.setState({
                tagBrandWarning,
                loading: false
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }
    }

    _getQuantityCombineShipNotGenLabel = async () => {
        this.setState({
            loading: true,
            error: ''
        })
        try {

            const {data: respons} = await notiCombineShip()
            const {success, data, message} = respons

            if (!success) return this.setState({
                error: message,
                loading: false
            })

            const { total } = data

            this.setState({
                combineShipWarning: total,
                loading: false
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }
    }

    _getQuantityComboNotCompete = async() => {
        try {
            const {data: respons} = await getQuantityComboNotCompete() 
            const {success, message, total} = {...respons}
            if (!success) return this.setState({
                error: message,
                loading: false
            })

            const QuantityComboNotCompete = total || 0

            this.setState({
                QuantityComboNotCompete: QuantityComboNotCompete,
                loading: false
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }
    }

    // Cảnh báo lô ship FBA có thùng đủ thông tin chờ gen label (chưa gen)
    _getFbaBatchPendingGenLabel = async () => {
        try {
            const {data: respons} = await countFbaBatchPendingGenLabel()
            const {success, data} = {...respons}
            if (!success) return
            this.setState({ fbaBatchPendingGenLabel: (data && data.total) || 0 })
        } catch (e) {
            // Không chặn render sidebar nếu API cảnh báo lỗi
        }
    }

    // Cảnh báo thùng FBA đủ 2 label chờ dán (chưa dán)
    _getFbaBoxPendingLabelled = async () => {
        try {
            const {data: respons} = await countFbaBoxPendingLabelled()
            const {success, data} = {...respons}
            if (!success) return
            this.setState({ fbaBoxPendingLabelled: (data && data.total) || 0 })
        } catch (e) {
            // Không chặn render sidebar nếu API cảnh báo lỗi
        }
    }

    loadStateFromProps = () => {
        const {isFullscreen, isOpenSidebarMobile} = this.props

        this.setState({
            isFullscreen: !!isFullscreen && !!isOpenSidebarMobile
        })
    }

    toggleFullscreen = () => {
        this.setState({
            isFullscreen: !this.state.isFullscreen
        })
    }

    renderSidebar = (sidebarItems) => {
        const {total, tagBrandWarning, combineShipWarning, QuantityComboNotCompete, fbaBatchPendingGenLabel, fbaBoxPendingLabelled} = this.state
        const {...rest} = this.props
        return sidebarItems
            // Ẩn khỏi menu nhưng vẫn giữ route để truy cập trực tiếp bằng URL
            .filter(sidebarItem => !sidebarItem.hidden)
            .filter(sidebarItem => {
                if(!sidebarItem.roles || (!!sidebarItem.roles && (sidebarItem.roles.includes('fac_admin') || sidebarItem.roles.includes('fac_ffm')))){
                    return sidebarItem
                }
            })
            .map((item, key) => {
                if (item.path === '/') {
                    return <SidebarItem {...rest} key={key} data={item} isOpenParent={true} total={QuantityComboNotCompete} isCollapsed={this.props.isCollapsed} totalTooltip={'Số lượng đơn combo chưa sản xuất xong'}/>
                }
                if (item.path === '/re-generate-labels') {
                    return <SidebarItem {...rest} key={key} data={item} isOpenParent={true} total={total} isCollapsed={this.props.isCollapsed}/>
                }
                if (item.path === '/brands-rule') {
                    return <SidebarItem {...rest} key={key} data={item} isOpenParent={true} total={tagBrandWarning} isCollapsed={this.props.isCollapsed}/>
                }
                if (item.path === '/combine-ship') {
                    return <SidebarItem {...rest} key={key} data={item} isOpenParent={true} total={combineShipWarning} isCollapsed={this.props.isCollapsed}/>
                }
                if (item.path === '/batch-ship') {
                    return <SidebarItem {...rest} key={key} data={item} isOpenParent={true} total={fbaBatchPendingGenLabel} isCollapsed={this.props.isCollapsed} totalTooltip={'Số lượng lô FBA có thùng đủ thông tin chờ gen label'}/>
                }
                if (item.path === '/next-boxes') {
                    return <SidebarItem {...rest} key={key} data={item} isOpenParent={true} total={fbaBoxPendingLabelled} isCollapsed={this.props.isCollapsed} totalTooltip={'Số lượng thùng FBA đủ label chờ dán'}/>
                }
                return <SidebarItem {...rest} key={key} data={item} isOpenParent={true} isCollapsed={this.props.isCollapsed}/>
            })
    }

    render() {
        const defaultProps = {
            dark: true,
            expand: 'md'
        }

        const {secondary, right, light, dark, color, expand, fixed, isCollapsed} = Object.assign({}, defaultProps, this.props)

        const sidebarClasses = classNames({
            'sidebar': true,
            'sidebar-main': true,
            'sidebar-secondary': secondary,
            'sidebar-right': right,
            'sidebar-light': light,
            'sidebar-fixed': fixed,
            'sidebar-dark': dark,
            ['sidebar-dark.bg-' + color]: color,
            ['sidebar-expand-' + expand]: expand,
            'sidebar-fullscreen': this.state.isFullscreen,
            'sidebar-collapsed': isCollapsed,
            'sizebar-expand': !isCollapsed
        })

        
        const token = getAccessToken()
        const userInfo = !!token && parseJwt(token)
        const {roles} = {...userInfo}
        const listRoles = !!roles && !!roles.length && roles.map(i=>i.name)

        return (
            <div className={sidebarClasses}>
                <div className="sidebar-mobile-toggler text-center">
                    <NavLink to={'#'} className="sidebar-mobile-main-toggle" onClick={this.props.toggleSidebarMobile}>
                        <i className="icon-arrow-left8"/>
                    </NavLink>
                    Navigation
                    <NavLink to={'#'} className="sidebar-mobile-expand" onClick={this.toggleFullscreen}>
                        <i className="icon-screen-full"/>
                        <i className="icon-screen-normal"/>
                    </NavLink>
                </div>

                <div className="sidebar-nav" onClick={this.props.toggleSidebarMenu}>
                    {
                        isCollapsed ? <RightOutlined style={{ fontSize: '12px', color: '#FFF'}}/> : <LeftOutlined style={{ fontSize: '12px', color: '#FFF'}}/>
                    }
                </div>

                <div className="sidebar-content">
                    <div className="card card-sidebar-mobile">
                        <ul className="nav nav-sidebar" data-nav-type="accordion">
                            {!!listRoles && !!listRoles.length && listRoles.includes('fac_admin') &&
                                <li className="nav-item">
                                    {
                                        isCollapsed ? <Tooltip placement="right" title='Tool 3D'>
                                        <a href={process.env.REACT_APP_URL_3D} className='nav-link' style={{ fontWeight: '600' }} >
                                            3D
                                        </a>
                                    </Tooltip> : <>
                                        <a href={process.env.REACT_APP_URL_3D} className='nav-link' style={{ fontWeight: '600' }} >
                                            3D
                                            <span>Tool 3D</span>
                                        </a>
                                    </>
                                    }
                                    
                                </li>
                            }
                            {this.renderSidebar(this.props.sidebar)}
                            <li className="nav-item Logout">
                                {
                                    isCollapsed ? <Tooltip placement="right" title='Logout'>
                                    <span style={{ display: 'block' }} onClick={() => logoutUser()}>
                                        <i className="icon-exit3"/>
                                    </span>
                                </Tooltip> : <>
                                    <span className="nav-link" onClick={() => logoutUser()}>
                                        <i className="icon-exit3"/>
                                        <span>Logout</span>
                                    </span>

                                </>
                                }
                                
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

Sidebar.propTypes = {
    secondary: PropTypes.bool,
    right: PropTypes.bool,
    light: PropTypes.bool,
    dark: PropTypes.bool,
    color: PropTypes.oneOf([
        'primary',
        'danger',
        'success',
        'warning',
        'info',
        'pink',
        'violet',
        'purple',
        'indigo',
        'blue',
        'teal',
        'green',
        'orange',
        'brown',
        'grey',
        'slate'
    ]),
    expand: PropTypes.oneOf(['xl', 'lg', 'md', 'sm'])
}

export default Sidebar
